var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutalt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.78,
    height: 24.339,
    viewBox: "0 0 26.78 24.339",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout_alt_2",
    "data-name": "logout alt 2",
    transform: "translate(19.395 17.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logout_alt_2-2",
    "data-name": "logout alt 2",
    transform: "translate(-19.395 -17.627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M4.652,16.3a1.217,1.217,0,0,1-.864-.353L1.354,13.516a1.217,1.217,0,0,1,0-1.728L3.788,9.354a1.222,1.222,0,0,1,1.728,1.728l-1.582,1.57,1.582,1.57A1.217,1.217,0,0,1,4.652,16.3Z",
    transform: "translate(-0.994 -0.482)",
    fill: "#ab9c7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M18.037,13.434H2.217a1.217,1.217,0,0,1,0-2.434h15.82a1.217,1.217,0,0,1,0,2.434Z",
    transform: "translate(-0.993 -0.048)",
    fill: "#ab9c7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M22.82,26.339H10.651A3.651,3.651,0,0,1,7,22.688V17.82a1.217,1.217,0,1,1,2.434,0v4.868A1.217,1.217,0,0,0,10.651,23.9H22.82a1.217,1.217,0,0,0,1.217-1.217V5.651A1.217,1.217,0,0,0,22.82,4.434H10.651A1.217,1.217,0,0,0,9.434,5.651v4.868a1.217,1.217,0,0,1-2.434,0V5.651A3.651,3.651,0,0,1,10.651,2H22.82a3.651,3.651,0,0,1,3.651,3.651V22.688A3.651,3.651,0,0,1,22.82,26.339Z",
    transform: "translate(0.309 -2)",
    fill: "#ab9c7d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutalt2);
export default __webpack_public_path__ + "static/media/logout alt 2.5ad9b492adcacefe5d5c5a80a8e800e3.svg";
export { ForwardRef as ReactComponent };